export const DISQ_PAGE_SIZE = 50;

export const extractList = (payload, keys = ['items', 'data', 'leagues', 'players', 'settings']) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  for (let i = 0; i < keys.length; i += 1) {
    const value = payload[keys[i]];
    if (Array.isArray(value)) return value;
  }
  return [];
};

export const isAutoSettingConfigured = (league) => (
  league != null && (Number(league.disqualEnabled) === 1 || league.disqualYC != null)
);

export const isManualDisqualification = (item) => (
  item && Number(item.is_auto) !== 1 && item.id != null
);

export const formatDate = (value) => {
  if (!value) return '';
  const text = String(value).slice(0, 10);
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return text;
  return `${match[3]}.${match[2]}.${match[1]}`;
};

export const playerFullName = (player, fallback = '') => {
  if (!player) return fallback;
  if (player.player_name) return player.player_name;
  const parts = [player.family, player.name, player.father_name].filter(Boolean);
  if (parts.length) return parts.join(' ');
  if (player.name) return player.name;
  return fallback;
};

export const formFromDisqualificationItem = (item) => {
  if (!item) return null;
  const hasDate = Boolean(item.to_date) && !(Number(item.matches_amount) > 0) && !item.matches;
  return {
    league_id: String(item.league_id == null ? 0 : item.league_id),
    player: {
      id: item.player_id || item.player?.id,
      player_name: item.player_name,
      name: item.player_name,
      ...(item.player || {}),
    },
    mode: hasDate ? 'time' : 'matches',
    matches_amount: item.matches || (item.matches_amount == null ? '' : String(item.matches_amount)),
    to_date: item.to_date || '',
    comment: item.comment || item.reason || '',
    tournament: item.tournament || '',
  };
};

export const formatDisqualificationTerm = (item, t) => {
  if (item?.matches) return item.matches;
  if (item?.to_date) return t('dqUntil', { date: formatDate(item.to_date) });
  return '—';
};
